import React from 'react';
import { Box, Typography, SxProps, Theme } from '@mui/material';
import StarIcon from '@mui/icons-material/Star';

interface PremiumBadgeProps {
    sx?: SxProps<Theme>;
    badgeText: string;
}

const PremiumBadge: React.FC<PremiumBadgeProps> = ({ sx, badgeText }) => {
    return (
        <Box
            sx={{
                position: 'absolute',
                top: '-10px',
                ...sx,
            }}
        >
            <Box
                sx={(theme) => ({
                    paddingLeft: '4px',
                    paddingRight: '8px',
                    borderRadius: '4px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '25px',
                    backgroundColor: theme.palette.primary.main,
                    position: 'relative',
                    overflow: 'hidden',
                })}
            >
                {/* Star Icon */}
                <StarIcon
                    sx={{
                        width: '16px',
                        height: '16px',
                        color: 'white',
                    }}
                />

                {/* Premium Text */}
                <Typography
                    component="div"
                    sx={{
                        fontWeight: 600,
                        fontSize: '12px',
                        color: 'white',
                        marginLeft: '4px',
                        lineHeight: 1,
                    }}
                >
                    {badgeText}
                </Typography>

                {/* Animated Gradient Badge */}
                <Box
                    component="svg"
                    width="28"
                    height="29"
                    viewBox="0 0 28 29"
                    fill="none"
                    sx={{
                        position: 'absolute',
                        top: '-5px',
                        left: '17px',
                        '@keyframes badgeSlide': {
                            '0%': {
                                transform: 'translateX(-100%)',
                            },
                            '100%': {
                                transform: 'translateX(150%)',
                            },
                        },
                        animation: 'badgeSlide 3s ease-in-out infinite',
                    }}
                >
                    <defs>
                        <filter
                            id="filter0_f_8527_2676"
                            x="0"
                            y="0.946289"
                            width="27.5"
                            height="28"
                            filterUnits="userSpaceOnUse"
                            colorInterpolationFilters="sRGB"
                        >
                            <feFlood floodOpacity="0" result="BackgroundImageFix" />
                            <feBlend
                                mode="normal"
                                in="SourceGraphic"
                                in2="BackgroundImageFix"
                                result="shape"
                            />
                            <feGaussianBlur
                                stdDeviation="2"
                                result="effect1_foregroundBlur_8527_2676"
                            />
                        </filter>
                        <linearGradient
                            id="paint0_linear_8527_2676"
                            x1="6"
                            y1="13.9463"
                            x2="15.5"
                            y2="15.9463"
                            gradientUnits="userSpaceOnUse"
                        >
                            <stop stopColor="white" />
                            <stop offset="1" stopColor="white" stopOpacity="0" />
                        </linearGradient>
                    </defs>
                    <g filter="url(#filter0_f_8527_2676)">
                        <path
                            d="M4 24.9463L10.5 4.94629H23.5L17 24.9463H4Z"
                            fill="url(#paint0_linear_8527_2676)"
                            fillOpacity="0.6"
                        />
                    </g>
                </Box>
            </Box>
        </Box>
    );
};

export default PremiumBadge;